import { _ } from "../../../polyglot/polyglot.js";
import {
	precisionFormatters,
	precisionsLabels,
} from "../../../../models/wysiwygEditor/builders/helpers.js";
import { select } from "../../../elements/index.js";
import regionWidget from "../../regionWidget.js";

/**
 * Build an input value popover section to handle the precision of formatting
 *
 * @param {string} precision - Originally selected precision
 * @param {function} onChange - Function triggered when the user change the
 *   selection
 * @param {predicate} shouldShowFn - When false, "hides" the section. Since
 *   popover can't be resized while rendered, it will grey out the section
 */
export default function precisionSectionBuilder({
	precision,
	onChange,
	shouldShowFn = () => true,
}) {
	return regionWidget({
		content: (html) => {
			html.div(
				{
					class: [
						"currency-precision",
						"popover-section",
						{ disabled: !shouldShowFn() },
					],
				},
				html.div(
					{
						klass: "right-menu-block",
						"data-test": "currency-precision",
					},
					html.span({ klass: "currency-label" }, _("Formatting")),
					html.div(
						select({
							items: Object.keys(precisionFormatters).map(
								(key) => ({
									value: key,
									label: precisionsLabels[key],
								}),
							),
							selected: precision,
							onChange,
						}),
					),
				),
			);
		},
	});
}
